import React from "react";
import { Formik, Form, ErrorMessage } from "formik";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import {
  Spinner,
  Form as BForm,
  InputGroup,
} from "@themesberg/react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { staffLoginSchema } from "./staffSchema";
import useSuperAdminSignin from "./useSuperAdminSignin"; // Use the merged hook
import VerificationForm from "./VerificationForm";
import { CommonRoutes } from "../../../routes";
import OwneesClubLogo from "../../../assets/img/Owners-Club-Logo.png"
import "./style.css"

const StaffLoginForm = ({ onSwitchToSuperAdmin }) => {
  const {
    loading,
    showPassword,
    setShowPassword,
    showVerification,
    verificationLoading,
    navigate,
    handleInitialLogin, // Staff-specific login handler
    handleVerificationSubmit,
    resetVerification,
  } = useSuperAdminSignin(); // Use the merged hook

  // Show verification form if needed
  if (showVerification) {
    return (
      <VerificationForm
        onSubmit={handleVerificationSubmit}
        onBack={resetVerification}
        loading={verificationLoading}
      />
    );
  }

  // Show initial login form
  return (
    <div className="bg-white p-2 p-lg-0 pt-lg-2 w-100">
      <div>
        <div>
        <h2 className="fw-bold">Welcome back!</h2>
        <h4 className="text-muted pb-2">Please Login </h4>
        </div>
      

        {/* <div className="text-center">
        <img src={OwneesClubLogo} className="loginLogo" />
      </div> */}
        <div className="text-center text-md-center mb-4 mt-md-0">
          {/* <h2 className="mb-0 login-heading">Sign In</h2> */}
        </div>
      </div>
      <Formik
        initialValues={{ user: "", password: "" }}
        validationSchema={staffLoginSchema}
        onSubmit={
          ({ user, password }) => handleInitialLogin({ user, password }) // Use staff-specific handler
        }
      >
        {({
          touched,
          errors,
          values,
          handleChange,
          handleSubmit,
          handleBlur,
        }) => (
          <div>
            <Form>
              <div className="form-group">
                <label
                  htmlFor="user"
                  className={touched.user && errors.user ? "text-danger lableFont mb-2" : "lableFont mb-2"}
                >
                  Email or Username
                </label>

                <InputGroup
                  className={
                    touched.user && errors.user ? "border border-danger" : ""
                  }
                >
                  <BForm.Control
                    name="user"
                    required
                    type="text"
                    placeholder="example@company.com"
                    value={values.user}
                    className="custom-height"
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                </InputGroup>

                <ErrorMessage
                  component="div"
                  name="user"
                  className="text-danger"
                />
              </div>

              <div className="form-group">
                <label
                  htmlFor="password"
                  className={`mt-3 mb-2 lableFont ${touched.password && errors.password ? "text-danger" : ""
                    }`}
                >
                  Password
                </label>

               

                <div className="position-relative">
                  <BForm.Control
                    name="password"
                    required
                    type={showPassword ? "text" : "password"}
                    placeholder="Enter your password"
                    value={values.password}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className={`custom-height pe-5 ${touched.password && errors.password ? "border border-danger" : ""}`}
                  />

                  <FontAwesomeIcon
                    icon={showPassword ? faEye : faEyeSlash}
                    onClick={() => setShowPassword((prev) => !prev)}
                    style={{
                      position: "absolute",
                      right: "12px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      color: "#6c757d",
                    }}
                  />
                </div>


                <ErrorMessage
                  component="div"
                  name="password"
                  className="text-danger"
                />
              </div>

              <div className="d-flex justify-content-end align-items-center">
                <p
                  className="mt-3 mb-0 mb-0"
                  style={{
                    color: "#0948b3",
                    cursor: "pointer",
                    fontSize: "1.1rem",
                  }}
                  onClick={() =>
                    navigate(CommonRoutes?.ForgotPassword, {
                      state: { isStaff: true },
                    })
                  }
                >
                  Forgot Password?
                </p>
              </div>
              <div className="d-flex justify-content-center">
              <button
                type="submit"
                className="btn btn-primary btn-block mt-4 mb-4 "
                onClick={handleSubmit}
                disabled={loading}
                style={{
                  // width: "calc(100% - 80px)", // 25px less from both sides
                  fontSize: "20px"
                  
                }}
              >
                {loading && (
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                    className="me-2"
                  />
                )}
                Sign In
              </button>
              </div>
            </Form>
          </div>
        )}
      </Formik>
    </div>
  );
};

export default StaffLoginForm;
